// Stellenangebote eines Standorts (Entscheidung F02): Recruiting pflegt sie über die
// eigenen Rechte. Technisch liegen sie im Standort-Inhalt der Website, die Endpunkte
// reichen aber nur an das Feld „jobs" heran.

import { api } from './core';

export interface Jobangebot {
  title: string;
  type?: string | null;
  hours?: string | null;
  desc?: string | null;
  image_url?: string | null;
}

export interface JobangeboteResponse {
  slug: string;
  /** Stand des Standort-Inhalts: 'draft' | 'published' … (vom Server geliefert). */
  status: string;
  jobs: Jobangebot[];
  veroeffentlichte_jobs: Jobangebot[];
  published_at: string | null;
}

const base = (standortId: number) => `/api/standorte/${standortId}/jobangebote`;

export const jobangeboteApi = {
  get: (standortId: number) => api.get<JobangeboteResponse>(base(standortId)),
  save: (standortId: number, jobs: Jobangebot[]) =>
    api.put<JobangeboteResponse>(base(standortId), { jobs }),
  publish: (standortId: number) =>
    api.post<JobangeboteResponse>(`${base(standortId)}/veroeffentlichen`, {}),
};
